<template>
    <div>
        <div class="d-flex flex-column vh-100">
            <div class="row vh-100 overflow-x-hidden">
                <div class="col-6 pl-0 bg-cover-center ml-minus-5px d-none d-lg-block p-0 login-right-img"
                     v-bind:style="{'background-image':'url(' + require('@/assets/img/login-right-bg.jpg')+')'}">
                    <div class="login-text">
                        {{ $t('toles_application_form').toUpper() }}
                    </div>
                </div>
                <div class="col-12 col-lg-6 bg-white rounded-lg mr-0 mr-md-minus-5px z-index-1 shadow">
                    <div class="d-flex align-items-start flex-column h-100">
                        <div class="my-auto w-100">
                            <div class="row justify-content-center p-5">
                                <div class="col-12 mb-4 d-flex justify-content-center">
                                    <div class="logo-wrapper"><img src="../assets/img/bau-logo-for-light.svg"></div>
                                </div>
                                    <slot></slot>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TolesApplicationLayout',
        created() {
        }
    }
</script>
